export const TERMS: Record<"PRIVACY_POLICY" | "USING_SERVICE" | "LOCATION_BASED_SERVICE", string> = {
  PRIVACY_POLICY: "/terms/privacy-policy.html",
  USING_SERVICE: "/terms/using-service.html",
  LOCATION_BASED_SERVICE: "/terms/location-based-service.html",
}
